export default __webpack_public_path__ + "static/media/Repressor's Trident.29f7a5a6.jpg";